import classNames from 'classnames';
import { formatDistanceToNowStrict } from 'date-fns';
import { Form, useFormikContext } from 'formik';
import { isEmpty } from 'lodash';
import React, { useContext, useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import Checkbox from '../../../components/form/Checkbox';
import Control from '../../../components/form/Control';
import { softwares } from '../../../components/mapView/constants';
import TextDivider from '../../../components/text/TextDivider';
import { DEFAULT_CURRENCY } from '../../../constants/price';
import { profileSelectors } from '../../../redux/selectors/profile';
import text, { formatCurrency } from '../../../text';
import { isJobPayable } from '../../../utilities/job';
import { isMembershipPriceId } from '../../../utilities/membership';
import { isStaff } from '../../../utilities/user';
import MembershipInvoice from '../Invoice/MembershipInvoice';
import useUser from '@/mp/hooks/useUser';
import { useAppSelector } from '@/hooks/useAppSelector';

const ConfirmationForm = () => {
  const currentUser = useUser();

  const membershipPriceId = useAppSelector(
    (state) => state.order.membershipPriceId
  );
  const paymentMethodId = useAppSelector(
    (state) => state.order.paymentMethodId
  );
  const membershipPrices = useAppSelector(
    (state) => state.profileReducer.membershipPrices
  );

  const { values, handleChange } = useFormikContext<{ terms: boolean }>();
  const hasValidMembership = useSelector(profileSelectors.hasValidMembership);

  const selectedMembership = membershipPrices.value.find(
    (m: any) => m.id === membershipPriceId
  );
  const currency = DEFAULT_CURRENCY;
  const totalPriceFormatted = formatCurrency(
    selectedMembership?.subtotal,
    currency.name,
    currency.scale_factor,
    {},
    true
  );

  return (
    // @ts-expect-error bad type
    <Form className='ConfirmationForm'>
      <div className='orderSummary'>
        <h4
          className={classNames({
            'mt-2 mb-5 text-center': true,
          })}
        >
          {text('confirmOrder')}
        </h4>
      </div>
      <div className='totalSummary'>
        {/* @ts-expect-error bad type */}
        <TextDivider isComplete />
        <Row
          className={classNames('Price', {
            'pt-1': true,
          })}
        >
          <Col xs={12} md={6}>
            <div style={{ fontWeight: 500 }} className='PriceHeader'>
              1. {text('membership')}
            </div>
          </Col>
          <Col>
            <h4 className='text-right'>
              {formatCurrency(
                selectedMembership.grand_total,
                currency.name,
                currency.scale_factor,
                {},
                true
              )}
            </h4>
          </Col>
        </Row>
        {/* Shown when not null - e.g TBC or ~2Hrs etc */}
      </div>
      <hr />

      {/* Start: Components below are visible on small screens (Mobile).
       *  Will revisit on mobile view tickets */}
      {/* End comment */}

      <div
        className={classNames('Terms', {
          'mt-4 mb-4 d-flex flex-row justify-content-center': true,
        })}
      >
        <Checkbox
          onChange={handleChange}
          name='terms'
          id='terms'
          value={values.terms}
          labelClass='ml-3'
        >
          {text('acceptTermsAndConditions', {
            termsConditions: (
              <Link
                key='urlTerms'
                to={{ pathname: process.env.LARKI_URL_TERMS }}
                target='_blank'
              >
                {text('termsAndConditions')}
              </Link>
            ),
          })}
        </Checkbox>
      </div>
    </Form>
  );
};

export default ConfirmationForm;
